import { defineStore } from "pinia";
import Autosomal, { createMapItem, flattenChildren } from "@/services/autosomal";
import store from "@/store/index";
import axios from "axios";
import endpoints from "@/endpoints";
import { resolveTileset } from "@/view/ancestry/recent/mapboxConfig";

export const useAutosomalStore = defineStore("autosomal", {
    state: () => ({
        result: {},
        previousVersions: [],
        previousResults: {},
        isLoading : false
    }),
    getters: {
        // Mapbox tileset for the active result's panel (e.g. the Irish panel upgrade),
        // falling back to the default tileset when the backend does not specify one.
        tileset: (state) => resolveTileset(state.result.tileset),
        regions: (state) => flattenChildren(state.result.regions),
        subregions() {
            return flattenChildren(this.regions);
        },
        combinedRegionsAndSubregions() {
            return [...this.regions, ...this.subregions];
        },
        mapItems() {
            // Items without a code cannot be drawn - on a starter result the locked regions
            // have had their code stripped server side, which is exactly what "not mappable"
            // means here. Skip them rather than adding layers that match no feature.
            return this.combinedRegionsAndSubregions
                .filter((item) => item.code)
                .map(createMapItem);
        },

        // autosomalComplete: (state) => state.complete,
        autosomalComplete: (state) => state.result.regions,
        autosomalCompleteRegion() {
            return flattenChildren(this.autosomalComplete)
        },
        autosomalCompleteSubRegion() {
            return flattenChildren(this.autosomalCompleteRegion)
        },
        autosomalCompleteMap() {
            return {
                data: [
                    ...this.autosomalCompleteSubRegion.map(createMapItem),
                    ...this.autosomalCompleteRegion.map(createMapItem),
                    ...this.autosomalComplete.map(createMapItem).filter(() => true),
                ],
            };
        },
    },
    actions: {
        async getAutosomalResults(barcode = null) {
            try {
                this.isLoading = true;
                const results = await Autosomal.getResults({
                    query: "speculative",
                    barcode: barcode || store.getters.profile.profile.barcode,
                });

                const activeResult = results.testData.autosomal.active_result;
                const tileset = results.testData.autosomal.tileset;
                const { speculative, ...rest } = results.testData.autosomal.data.current;
                this.result = {
                    ...rest,
                    activeResult,
                    tileset,
                    regions: speculative,
                };
                this.previousVersions = results.testData.autosomal.results;
                this.isLoading = false;
            } catch (e) {
                this.isLoading = false;
                console.error(e);
                throw e;
            }
        },
        async getPreviousVersions() {
            const { data } = await axios.get(
                endpoints.getPreviousAutosomalResult(store.getters.profile.barcode) + "?all=true"
            );
            this.previousResults = data;
        },
        async startUpdate() {
            await axios.post(endpoints.upgradeTest(store.getters.profile.barcode, "autosomal"));
        },
    },
});
